(ns iris.styles.posts
  (:require
   ;;    [herb.core :refer [<class <id]]
   ;;  [garden.units :refer [px]]
   [shadow.css :refer [css]]))



(def $container
  (css
   :w-auto
   ["@media (min-width: 748px)" {:width "748px"}]))

;; NOTE:
;; there is app.css code that overrides $post-screening-options:
;; .post-wrap.mobile article footer .ip-buttons .btn {
;;     padding: 5px 10px;
;;     margin: 2px 4px 2px 0
;; }
(defn $post-screening-options [mobile]
  (when (true? mobile)
    (css
     ["&>a" {:padding "5px 10px !important"
             :margin "2px 4px 2px 0"}])))

(defn $counter-red [r n]
  (when (>= n r)
    (css {:font-weight "bold"
          :color "rgb(169, 68, 66)"})))


(def $all-moderator-logs-ul
  (css {:margin "0"
        :padding "0 0 0 20px"
        :position "relative"
        :list-style-type "disc"}))

(def $all-moderator-logs-more-btn
  (css {:float "right"
        :list-style "none"}
       ["@media (min-width: 480px)" {:position "absolute"
                                     :right "0"
                                     :bottom "0"
                                     :cursor "pointer"}]))

(def $filter-display-labels
  (css
   {:display "none"}
   ["@media (min-width: 1024px)" {:display "inline"}]))



(def $post-ref-refresh
  (css
   {:color "var(--iris-post-ref-preview-control)"
    :opacity "var(--iris-post-ref-preview-refresh-opacity)"
    :font-size "12px"}
   [:hover {:color "var(--iris-post-ref-preview-control-hover)"
            :opacity "var(--iris-post-ref-preview-refresh-hover-opacity)"}]))


(def $post-ref-status
  (css {:float "right"
        :font-weight "bold"
        :color "var(--iris-post-ref-preview-status)"}
       [:hover {:color "var(--iris-post-ref-preview-status-hover)"}]))

(def $post-ref-close
  (css {:color "var(--iris-post-ref-preview-control) !important"
        :opacity "0.45 !important"}
       ["& > span" {:color "inherit !important"}]
       [:hover {:color "var(--iris-post-ref-preview-control-hover) !important"
                :opacity "0.75 !important"}]
       ["&:hover > span" {:color "inherit !important"}]))

(def $skeleton-stack
  (css {:display "flex"
        :flex-direction "column"
        :gap "10px"
        :max-width "100%"
        :width "100%"
        :margin "0 auto"
        :padding "clamp(10px, 3vw, 24px) 0"}))

(def $skeleton-post
  (css {:border "1px solid var(--iris-border-soft) !important"
        :border-radius "3px"
        :overflow "hidden"
        :background "var(--iris-surface)"
        :box-shadow "none !important"
        :margin "0 !important"}))

(def $skeleton-header
  (css {:display "flex"
        :align-items "center"
        :justify-content "space-between"
        :gap "12px"}))

(def $skeleton-body
  (css {:padding "14px 12px 16px"
        :display "flex"
        :flex-direction "column"}))

(def $skeleton-body-reply
  (css {:gap "9px"}))

(def $skeleton-body-thread
  (css {:gap "10px"}))

(def $skeleton-footer
  (css {:background "var(--iris-surface-alt)"
        :border-top "1px solid var(--iris-border-soft)"
        :padding "10px 12px"}))

(def $skeleton-bone
  (css {:background-color "var(--iris-skeleton-bone)"
        :background-image "linear-gradient(90deg, var(--iris-skeleton-bone) 35%, var(--iris-skeleton-shine) 50%, var(--iris-skeleton-bone) 65%)"
        :background-size "300% 100%"
        :animation "post-skeleton-shimmer 1.6s linear infinite"
        :border-radius "3px"
        :flex "none"}
       ["@media (prefers-reduced-motion: reduce)" {:background-image "none"
                                                   :animation "none"}]))

(def $skeleton-button-bone
  (css {:border-radius "3px"}))

(def $skeleton-table-cell
  (css {:padding "10px 8px"}))

(def $skeleton-table-row
  (css {:display "flex"
        :align-items "center"
        :gap "10px"
        :flex-wrap "wrap"}))

(def $skeleton-table-stack
  (css {:display "flex"
        :flex-direction "column"
        :gap "8px"}))



;; (def $moderator-logs-empty-list
;;   (css {:background-color "lightslategrey"
;;         :margin "5px"
;;         :border-radius "3px"
;;         :padding "5px 10px"
;;         :text-align "center"}))


;; (defn container []
;;   ^{:media {{:screen :only :min-width "748px"} {:width "748px"}}}
;;   {:width "auto"})


;; (defn post-screening-options [mobile]
;;   ^{:combinators {[:> :a]  (when (true? mobile) {:padding "5px 10px !important"
;;                                                  :margin "2px 4px 2px 0"})}}
;;   {})


;; (defn font-size [size]
;;   ;; this works, but... it generates new css class for each resize event and inserts it into stylesheet
;;   ;; also selectors are very, very specific...
;;   ;; decided on a simpler approach, predefined font-size-x classes in styles/general.cljs
;;   ^{:combinators {[:> :.row :article :div :.post-body] {:font-size (str size "% !important")}
;;                   [:> :.row :article :header :.post-title :a] {:font-size (str size "% !important")}
;;                   [:> :.row :article :header :.post-title :span] {:font-size (str size "% !important")}}}
;;   {})

;; (defn counter-red [r n]
;;   (if (>= n r)
;;     {:font-weight "bold"
;;      :color "rgb(169, 68, 66)"}
;;     {}))

;; (defn moderator-logs []
;;   ^{:media {{:screen :only :min-width "1180px"} {:display "block"
;;                                                  :width "200px"}
;;             {:screen :only :min-width "1800px"} {:display "block"
;;                                                  :width "400px"}
;;             {:screen :only :min-width "768px"} {:top "25px"}}}
;;   {
;;   ;;  :display "none"
;;    :display "block"
;;    :width "100%"
;;    :height "100%"
;;    :position "fixed"
;;    :right 0
;;    :top "50px"
;;    :background-color "navy"
;;    :color "white"
;;    :overflow-y "auto"
;;    :z-index 1})

;; (defn moderator-logs-h3 []
;;   {:font-family "inherit"
;;    :font-size "20px"
;;    :margin "5px 10px"})

;; (defn moderator-logs-p []
;;   {:font-family "inherit"
;;    :margin "5px 10px"})

;; (defn moderator-logs-ul []
;;   {:list-style "none" :padding 0 :margin-bottom "55px"})

;; (defn moderator-logs-li []
;;   ^{:pseudo {":nth-child(even)" {:background-color
;;                                 ;;  "rgb(245, 247, 215)"
;;                                  "mintcream"
;;                                  }}}
;;   {:background-color
;;   ;;  "mintcream"
;;   ;;  "khaki"
;;    "lightcyan"
;;    :margin "5px"
;;    :border-radius "3px"})

;; (defn moderator-logs-li-empty-list []
;;   {:background-color "lightslategrey"
;;    :margin "5px"
;;    :border-radius "3px"
;;    :padding "5px 10px"
;;    :text-align "center"})

;; (defn moderator-logs-li-a []
;;   ^{:pseudo {:hover {:color
;;                     ;;  "dimgrey"
;;                      "#666"
;;                        :text-decoration "none"
;;                        :cursor "pointer"}}
;;     :media {{:screen :only :min-width "1180px"} {:padding "5px 10px"}
;;             {:screen :only :min-width "1920px"} {:padding "5px 25px"}}}
;;   {
;;   ;;  :display "block"
;;    :display "inline-block"
;;    :padding "5px 25px"
;;    :text-decoration "none"
;;    :color "darkblue"})


;; (defn all-moderator-logs-ul []
;;   {:margin 0
;;    :padding "0 0 0 20px"
;;    :position "relative"})

;; (defn all-moderator-logs-more-btn []
;;   ^{:media {{:screen :only :min-width "480px"} {:position "absolute"
;;                                                 :right 0
;;                                                 :bottom 0
;;                                                 :cursor "pointer"}}}
;;   {:float "right"
;;    :list-style "none"})

;; (defn filter-display-labels []
;;   ^{:media {{:screen :only :min-width "1024px"} {:display "inline"}}}
;;   {:display "none"})


;; (defn post-ref-refresh []
;;   ^{:pseudo {:hover {:opacity "0.5"}}}
;;   {:color "#000"
;;    :opacity "0.25"
;;    :font-size "12px"})

;; (defn post-ref-status []
;;   ^{:pseudo {:hover {
;;                     ;;  :opacity 0.75
;;                      :color "#333"
;;                      }}}
;;   {:float "right"
;;    :font-weight "bold"
;;    :color "#666"
;;   ;;  :opacity 0.5
;;    }
;;   )



(def $edit-votes-form-container
  (css :flex :justify-center))

(def $edit-votes-form
  ;; (css
  ;;  :flex
  ;;  :items-end
  ;;  :space-x-4)
  (css :flex :flex-wrap :items-end :space-x-4))

(def $edit-votes-form-div
  (css
   :flex :flex-col))


(def $edit-votes-form-label
  ;; (css
  ;;  :block
  ;;  :text-sm
  ;;  :text-gray-700)
  (css :text-sm :font-medium
       {:color "var(--iris-text)"})
  
  )



(def $edit-votes-form-input
  ;; (css
  ;;  :block
  ;;  :w-20
  ;;  :rounded
  ;;  :border
  ;;  :border-gray-300
  ;;  :px-2
  ;;  :py-1)
  (css 
   :mt-1 :block :w-24 :rounded-md :border :px-2 :py-1 :shadow-sm
   {:background-color "var(--iris-input-bg)"
    :border-color "var(--iris-input-border)"
    :color "var(--iris-input-text)"})
  )

(def $edit-votes-form-button
  ;; (css
  ;;  :h-9
  ;;  :px-4
  ;;  :rounded
  ;;  :bg-blue-600
  ;;  :text-white
  ;;  :hover:bg-blue-700)
  (css
  ;;  :mt-5
   :h-14 :px-4 :rounded-md :text-white :transition
   {:background-color "#315f8d"
    :border "1px solid #54789f"}))

(def $edit-votes-form-button-container
  ;; (css
  ;;  :flex
  ;;  :items-end
  ;;  :space-x-4)
  (css :flex :flex-col :justify-end)
  )
 


(defn $post-tags-divider [mobile tags]
  (let [$base (css {:display "block"
                    :border "none"
                    :height "1px"
                    :width "90%"
                    :background-color "#dee2e6"})
        $margin (if (and (true? mobile) (pos? (count tags)))
                  (css {:margin "10px auto"})
                  (css {:margin "auto"}))]
    [$base $margin]))
